var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.623 13.0212L14.6294 14.4811C14.204 15.115 13.5793 15.5891 12.8525 15.8283C12.1264 16.0668 11.3408 16.0567 10.6213 15.7987C5.73993 14.1038 1.90193 10.2768 0.201847 5.40774C-0.0568575 4.68932 -0.0670054 3.90586 0.172135 3.18097C0.41201 2.45605 0.8874 1.83159 1.52367 1.40735L3.28103 0.218425C3.56365 0.0268878 3.91221 -0.0424962 4.24702 0.0254445C4.58182 0.0933835 4.87531 0.29286 5.06155 0.579073L6.66237 3.04877C7.04066 3.63202 6.87687 4.41116 6.29568 4.79422C5.84637 4.9872 5.50069 5.36013 5.34417 5.82197C5.18765 6.28381 5.23402 6.78974 5.47244 7.2147C6.28408 8.58721 7.43188 9.73195 8.8075 10.5414C9.23434 10.7792 9.74162 10.8255 10.2047 10.6694C10.667 10.5132 11.0417 10.1685 11.2352 9.72039C11.6192 9.14074 12.4004 8.97741 12.9853 9.35467L15.4616 10.9512C16.0602 11.3372 16.223 12.1386 15.623 13.0212Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.020eb0e1b705c0358d642339f5dadafe.svg";
export { ForwardRef as ReactComponent };